import React from "react";
import { MSTableColumnSettingSubHeader } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/sortable-context/sub-header";
import SHSortableContext from "@components/design-systems/sh-sortable-context";
import {
  ModelScreenerColumnSettingData,
  ModelScreenerColumnSettingDTO,
} from "@models/model-screener/entities/modelScreenerFilter";
import { DragEndEvent } from "@dnd-kit/core";
import { useFormContext } from "react-hook-form";
import { getCurrentMainHeaderFieldPathById } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/column-setting/utils";

type MSTableColumnSettingSubHeaderSectionProps = {
  mainHeaderId: string;
  subHeaders: ModelScreenerColumnSettingData[];
  disabled?: boolean;
};

export const MSTableColumnSettingSubHeaderSection = React.memo(
  ({
    mainHeaderId,
    subHeaders,
    disabled,
  }: MSTableColumnSettingSubHeaderSectionProps) => {
    // Forms
    const { setValue, getValues } =
      useFormContext<ModelScreenerColumnSettingDTO>();

    // Functions
    const handleOnSubHeaderDragEnd = (
      _: DragEndEvent,
      items: ModelScreenerColumnSettingData[],
    ) => {
      const formData = getValues();
      const currentMainHeaderFieldPath = getCurrentMainHeaderFieldPathById(
        mainHeaderId,
        formData,
      );

      const currentSubHeaders =
        (getValues(
          currentMainHeaderFieldPath.columnSettings,
        ) as ModelScreenerColumnSettingData[]) || [];

      const visibilityMap = new Map(
        currentSubHeaders.map((elem) => [elem.id, elem.isVisible]) || [],
      );

      const newValue = items?.map((item, index) => ({
        ...item,
        order: index + 1,
        isVisible: !!visibilityMap.get(item.id),
      }));
      setValue(currentMainHeaderFieldPath.columnSettings, newValue);
    };

    return (
      <SHSortableContext
        key={mainHeaderId}
        items={subHeaders}
        getItemId={(item) => item.id}
        renderSortableItem={(item) => (
          <MSTableColumnSettingSubHeader
            id={item.id}
            key={item.id}
            item={item}
            mainHeaderId={mainHeaderId}
            disabled={disabled}
          />
        )}
        onDragEnd={handleOnSubHeaderDragEnd}
      />
    );
  },
);
